module.exports = __webpack_public_path__ + "img/locked.1b349959.svg";